import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import AddIcon from "@mui/icons-material/Add";
import { Box, Typography } from "@mui/material";
import { MenuList } from "Static/utils/menuList";
import { PermissionAction, actionsPermissionValidator, matches } from "Static/utils/commonUtils";
import { PUCBreadActiveNavLink, PUCNavLink, PucFillAddButton } from "Helpers/overrides";
import { NavLink } from "react-router-dom";

export default function AdminBreadcrumbs() {
  const [breaddata, setBreadData] = React.useState({
    section: "",
    subSection: ""
  });

  const breadboxstyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row"
  };

  /**
   * Finds the title associated with the given path in the nested menu structure.
   *
   * @param {string} path - The path for which to find the associated title.
   * @param {array} menuList - The menu list to search through.
   * @returns {string|null} - The title associated with the path, or null if not found.
   */
  const findTitleByPath = (path, menuList) => {
    // Remove /view or /update from the path
    const cleanedPath = path.replace(matches.breadmatch, "");

    for (const menuGroup of menuList) {
      for (const menuItem of menuGroup.list) {
        if (menuItem.path === cleanedPath) {
          return menuItem;
        } else if (cleanedPath.startsWith(menuItem.path) && menuItem.list) {
          // Recursively search for the title in the nested menu
          const nestedTitle = findTitleByPath(cleanedPath, menuItem.list);
          if (nestedTitle) {
            return nestedTitle;
          }
        }
      }
    }
    return null;
  };

  /**
   * useEffect hook to update the breadcrumb data based on the current window location pathname.
   */
  React.useEffect(() => {
    const path = window.location.pathname;

    // Find the title associated with the current window location pathname
    const title = findTitleByPath(path, MenuList);
    // Set the breadcrumb data with the found section title
    setBreadData({
      section: title,
      subSection: ""
    });

    // Check for specific paths and update subSection accordingly
    if (path.includes("/view")) {
      setBreadData((prevData) => ({
        ...prevData,
        // subSection: title.view
        subSection: title.view !== undefined || null ? title.view : ""
      }));
    } else if (path.includes("/update")) {
      setBreadData((prevData) => ({
        ...prevData,
        // subSection: title.update
        subSection: title.update !== undefined || null ? title.update : ""
      }));
    } else if (path.includes("/add")) {
      setBreadData((prevData) => ({
        ...prevData,
        subSection: title.add !== undefined ? title.add : ""
      }));
    } else if (path.includes("/edit")) {
      setBreadData((prevData) => ({
        ...prevData,
        subSection: title.edit
      }));
    }
  }, [window.location.pathname]);

  return (
    <Box sx={breadboxstyle}>
      <Box>
        {breaddata.section.title && (
          <Typography variant="h6">
            {breaddata.subSection ? `${breaddata.subSection}` : breaddata.section.title}
          </Typography>
        )}

        {breaddata.section.title === "Home" && breaddata.subSection === "" ? (
          ""
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            {breaddata.section.title === "Home" && breaddata.subSection !== "" ? (
              ""
            ) : (
              <PUCNavLink
                color="inherit"
                underline="hover"
                to="/admin/home"
                className={
                  window.location.pathname.replace(matches.breadmatch, "") ===
                  window.location.pathname
                    ? "breadactive"
                    : "breadnotactive"
                }>
                Home
              </PUCNavLink>
            )}

            <PUCNavLink
              className={
                window.location.pathname.replace(matches.breadmatch, "") ===
                window.location.pathname
                  ? "breadactive"
                  : "breadnotactive"
              }
              underline="hover"
              color="inherit"
              to={window.location.pathname.replace(matches.breadmatch, "")}
              aria-current="page">
              {breaddata.section.title}
            </PUCNavLink>
            {breaddata.subSection ? (
              <PUCBreadActiveNavLink
                className={
                  window.location.pathname.replace(matches.breadmatch, "") ===
                  window.location.pathname
                    ? "breadnotactive"
                    : "breadactive"
                }
                underline="hover"
                color="inherit"
                to={window.location.pathname}
                aria-current="page">
                {breaddata.subSection}
              </PUCBreadActiveNavLink>
            ) : (
              ""
            )}
          </Breadcrumbs>
        )}
      </Box>
      {window.location.pathname.includes("/view") ||
      window.location.pathname.includes("/update") ||
      window.location.pathname.includes("/add") ||
      window.location.pathname.includes("/edit") ? (
        ""
      ) : (
        <>
          {breaddata.section.add !== undefined ? (
            actionsPermissionValidator(window.location.pathname, PermissionAction.ADD) ? (
              <NavLink to={window.location.pathname.replace(matches.breadmatch, "") + "/add"}>
                <PucFillAddButton>
                  <AddIcon />
                  {breaddata.section.add}
                </PucFillAddButton>
              </NavLink>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </>
      )}
    </Box>
  );
}
